<template>
  <div>
    <section class="py-[4rem]">
      <div class="max-w-7xl m-auto">
        <div class="flex flex-col gap-4 px-5 lg:px-0">
          <h2
            class="text-black font-bold text-left text-[24px] lg:text-center lg:text-[35px]"
          >
            #ItAllAddsUp
          </h2>
          <div class="slick_italladds flex flex-wrap gap-4 justify-between">
            <div
              class="lg:w-[290px] md:h-[420px] px-4"
              v-for="italladd in italladds"
              :key="italladd"
            >
              <div class="bg-white border shadow-lg rounded-xl">
                <div>
                  <img
                    :src="italladd.image"
                    alt=""
                    srcset=""
                    class="w-full h-[250px]"
                  />
                </div>
                <div class="p-4 flex flex-col gap-3 h-[170px]">
                  <h2 class="text-black font-bold lg:text-[18px] text-left">
                    {{ italladd.title }}
                  </h2>
                  <p class="text-black text-[14px] text-left">
                    {{ italladd.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "ItAllAddsUpView",
  data() {
    return {
      italladds: [
        {
          id: 1,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-1mobile.webp"),
          title: "Ease of Admission",
          description:
            "Admissions made easy with streamlined processes for hassle-free enrollment.",
        },
        {
          id: 2,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-2mobile.webp"),
          title: "Range of Electives",
          description:
            "An extensive spectrum of electives catering to diverse academic interests and career aspirations.",
        },
        {
          id: 3,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-3mobile.webp"),
          title: "Flexible Payment Options",
          description:
            "Choose from various payment plans designed to fit your individual financial needs and circumstances.",
        },
        {
          id: 4,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-4mobile.webp"),
          title: "Highly Experienced Faculties",
          description:
            "Tap into the wealth of experience and expertise of our faculty members.",
        },
        {
          id: 5,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-5mobile.webp"),
          title: "Learner Support - JOSH",
          description:
            "Get all your queries and doubts resolved through JOSH (JAIN Online Support & Help).",
        },
        {
          id: 6,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-6mobile.webp"),
          title: "On-Campus-Like Experience with Engage",
          description:
            "Experience a fully immersive campus-like environment with our learner community - Engage.",
        },
        {
          id: 7,
          image: require("@/assets/electiveDetail/career&addsup/Itall-adds-up-7mobile.webp"),
          title: "Career Advancement Services Powered by foundit",
          description:
            "Accelerate your career with tailored services powered by foundit.",
        },
      ],
    };
  },
  mounted() {
    $(`.slick_italladds`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",

      responsive: [
        {
          breakpoint: 1040,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style></style>
